
import { ChevronLeftIcon } from 'vue-feather-icons';
import { Button, Dialog, Alert } from 'element-ui';
export default {
  data() {
    return {
      loading: false,
      showed: false,
      error: null,
      mobileOS: null,
    };
  },
  computed: {
    loyaltyCustomer() {
      return this.$store.state.shop.loyalty.customer;
    },
    googlewallet() {
      return this.$store.state.account.googlewallet;
    },
    walletData() {
      return this.googlewallet.data;
    },
  },
  methods: {
    loadGoogleWalletLink() {
      this.$store.dispatch('account/googlewallet/fetchData');
    },
    openDialog() {
      this.showed = true;
    },
    closeDialog() {
      this.showed = false;
    },
  },
  mounted() {
    this.mobileOS = this.$detectMobileOS();
    this.loadGoogleWalletLink();
  },
  components: {
    Button,
    Dialog,
    ChevronLeftIcon,
    Alert,
  },
};
